module.exports = __webpack_public_path__ + "static/media/congrats.8646f7e2.png";